import "core-js/modules/es.array.concat.js";
import React from 'react';
import { AppLink } from '@finect/tabular-core/AppLink';
import { getProductTypeLabel, getManagementCompanyPath } from '@finect/front-resources/Products';
import { useTheme } from 'styled-components';
import { Tag } from '../../Tags';
export var ManagementCompanyTag = function ManagementCompanyTag(props) {
  var theme = useTheme();
  var entity = props.entity,
    productType = props.productType;
  return React.createElement(AppLink, {
    href: getManagementCompanyPath(theme, productType, entity),
    title: "Ver ".concat(getProductTypeLabel(productType, 'plural', 'lowercase'), " de la gestora ").concat(entity.name)
  }, React.createElement(Tag, {
    withMargin: true
  }, entity.name));
};